module.exports = __webpack_public_path__ + "assets/images/shop4.fa15baad.jpg";